const DEFAULT_APP_ORIGIN = 'https://app.vibesprint.ai';

export const APP_ORIGIN = (
  process.env.REACT_APP_APP_ORIGIN || DEFAULT_APP_ORIGIN
).replace(/\/$/, '');

export const APP_DASHBOARD_URL = `${APP_ORIGIN}/app`;
